import { formatISO9075 } from "date-fns";

import { IRealization4CSV } from "../state";

export function convertRealizationsToCsv(realizations: IRealization4CSV[]) {
  return realizations.map(realization =>
    [
      realization.id,
      realization.student?.current_grade ?? "",
      realization.student?.klass_name ?? "",
      realization.student?.identity ?? "",
      realization.student?.student_no_in_school ?? "",
      realization.student?.full_name ?? "",
      realization.kind.toUpperCase(),
      realization.content ?? "",
      realization.roots_created_at
        ? formatISO9075(realization.roots_created_at)
        : "",
      realization.is_executed ? "✔" : "",
      realization.executed_at ? formatISO9075(realization.executed_at) : "",
      realization.origin_realization?.content ?? "",
      realization.origin_realization?.created_at
        ? formatISO9075(realization.origin_realization.created_at)
        : "",
      realization.origin_realization?.student?.full_name ?? "",
      realization.has_image ? "あり" : "なし",
      realization.categories.map(category => category.name)?.join("\r\n") ?? "",
      realization.gearbox_title ?? "",
      realization.submitted_teacher_names?.join("\r\n") ?? "",
      realization.shared ? "✔" : "",
      realization.shared_classes.join("\r\n"),
      realization.favorites_count,
      realization.comments_count,
      realization.comment_details?.join("\r\n") ?? "",
      realization.ai_comment_details?.join("\r\n") ?? "",
      realization.feedback_details?.join("\r\n") ?? "",
      realization.experience_nos?.includes(1) ? "✔" : "-",
      realization.experience_nos?.includes(2) ? "✔" : "-",
      realization.experience_nos?.includes(3) ? "✔" : "-",
      realization.experience_nos?.includes(4) ? "✔" : "-",
      realization.experience_nos?.includes(5) ? "✔" : "-",
      realization.experience_nos?.includes(6) ? "✔" : "-",
      realization.experience_nos?.includes(7) ? "✔" : "-",
    ].map(value =>
      typeof value === "string" ? value.replaceAll('"', '""') : value,
    ),
  );
}
